import { createSlice } from '@reduxjs/toolkit';

export const FJSliceClothesChanger = createSlice({
    name: 'clothesChanger',
    initialState: {
        peopleImageInfo: {},
        clothesImageInfo: {},
        selectedStyle: '',
    },
    reducers: {
        setSlicePeopleImageInfoAction: (state, action) => {
            state.peopleImageInfo = action.payload;
        },
        setSliceClothesImageInfoAction: (state, action) => {
            state.clothesImageInfo = action.payload;
        },
        setSliceSelectedStyleAction: (state, action) => {
            state.selectedStyle = action.payload;
        },
    },
});

export const { setSlicePeopleImageInfoAction, setSliceClothesImageInfoAction, setSliceSelectedStyleAction } =
    FJSliceClothesChanger.actions;

export default FJSliceClothesChanger.reducer;
